import CloseIcon from "@material-ui/icons/Close";
import close_contract from "~/assets/images/close_contract.svg";
import Loading from "~/components/layout/Loading";
import api from '~/services/api';
import moment from "moment";
import PDFViewer from 'pdf-viewer-reactjs'
import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";

import CustomNavigation from "../CustomNavigation";
import { BoxTitle, Column, Dates, Details, DivisionTitleModal, Divisor, DocumentContainer, DownloadButton, DownloadIcon, IconInformation, ItemDetails, Left, ModalContent, Right, Title, TitleModal } from "./styles";

import "~/components/styles/Contracts.css";
import "~/components/styles/Global.css";

export default function ModalContracts({
  contract,
  showModal,
  activeModal,
  dowloadContent,
  index
}) {

  const [attachment, setAttachment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [completeRequest, setCompleteRequest] = useState(false);

  function getContracts() {
    setCompleteRequest(true);
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };

    const parameters = {
      method: 'GET',
      headers: header,
    };

    const url = `/residential/store/v1/stores/${localStorage.getItem(
      "storeId"
    )}/attachments/${contract.attachmentId}`;

    api.get(url, parameters)
    .then((res) => {
      setAttachment(res.data.attachment);
      setCompleteRequest(false);
      setLoading(false);
    })
    .catch((err) => {})
  }

  useEffect(() => {
    if(showModal) {
      setLoading(true);
      getContracts();
    }
  }, [showModal]);

  return (
    <Modal
      show={showModal}
      onHide={() => {
        activeModal(false);
      }}
      className="modal-contrato"
      centered={window.screen.width >= 768}
      scrollable={true}
    >
      <Modal.Body scrollable={true} style={{
        overflow: window.screen.width > 770 ? "scroll" : "hidden",
        padding: ".5rem",
        borderRadius: 15
      }}>
        {
          loading ? <Loading margin="100% auto" /> : (
          <ModalContent>
            <DivisionTitleModal>
            <TitleModal>
              <div>
                Detalhes
              </div>
              <span>
                {contract ? contract.contractType : null} {index + 1}
              </span>
            </TitleModal>
            <img src={close_contract} alt="Ícone de fechar" onClick={() => {
              setAttachment(null);
              activeModal(false);
            }}/>
            </DivisionTitleModal>
            <Left>
              <Dates>
                <Column>
                  <Title style={{ fontSize: 14 }}>Data início:</Title>
                  <ItemDetails>
                    {contract ? moment(contract.beginDate, "YYYY-MM-DD").format("DD/MM/YYYY") : null}
                  </ItemDetails>
                </Column>
                <Column>
                  <Title style={{ fontSize: 14 }}>Vencimento:</Title>
                  <ItemDetails>
                    {contract ? moment(contract.endDate, "YYYY-MM-DD").format("DD/MM/YYYY") : null}
                  </ItemDetails>
                </Column>
              </Dates>
                {
                  loading || attachment === null ? null : (
                    <BoxTitle>
                      <Title>
                        {contract ? contract.contractNumber : null}
                      </Title>
                      <DownloadButton className="mr-2">
                        <DownloadIcon
                          className="mdi mdi-download"
                          onClick={() => dowloadContent(attachment, contract)}
                        />
                      </DownloadButton>
                    </BoxTitle>
                  )
                }
            </Left>
            <hr />
            {
              loading || attachment === null ? <Loading margin="100% auto" /> : (
                <DocumentContainer>
                  <PDFViewer
                    css="viewr"
                    document={{
                      base64: attachment,
                    }}
                    navigation={CustomNavigation}
                    loader={<Loading margin="100% auto" />}
                    navbarOnTop
                  />
                </DocumentContainer>
              )
            }
          </ModalContent>
          )
        }
      </Modal.Body>
    </Modal>
  );
}
